import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { share, tap, catchError } from 'rxjs/operators';
import { LoadingService } from '../loading-service/loading.service';


@Injectable({ providedIn: 'root' })
export class WebServices {
  constructor(
    private http: HttpClient,
    private loadingService: LoadingService
  ) {}

  public httpPost(
    url: string,
    body: any,
    headers: any = {},
    hideLoading?: boolean
  ): Observable<any> {
    const loadingUrl = url + crypto.randomUUID();
    const shouldShow = !hideLoading;
    if (shouldShow) {
      this.loadingService.addToLoadingQueue(loadingUrl);
    }
    return this.http.post(`${url}`, body, headers).pipe(
      tap((results) => {
        if (shouldShow) {
          this.loadingService.removeFromLoadingQueue(loadingUrl);
        }
        return results;
      }),
      share()
    );
  }

  public httpPatch(
    url: string,
    body: any,
    hideLoading?: boolean
  ): Observable<any> {
    const loadingUrl = url + crypto.randomUUID();
    const shouldShow = !hideLoading;
    if (shouldShow) {
      this.loadingService.addToLoadingQueue(loadingUrl);
    }
    return this.http.patch(`${url}`, body).pipe(
      tap((results) => {
        if (shouldShow) {
          this.loadingService.removeFromLoadingQueue(loadingUrl);
        }
        return results;
      }),
      share()
    );
  }

  public httpGet(
    url: string,
    options = {},
    hideLoading?: boolean
  ): Observable<any> {
    const loadingUrl = url + crypto.randomUUID();
    const shouldShow = !hideLoading;
    if (shouldShow) {
      this.loadingService.addToLoadingQueue(loadingUrl);
    }
    return this.http.get(`${url}`, options).pipe(
      tap((results) => {
        if (shouldShow) {
          this.loadingService.removeFromLoadingQueue(loadingUrl);
        }
        return results;
      }),
      share()
    );
  }

  public httpDelete(
    url: string,
    body?: any,
    hideLoading?: boolean
  ): Observable<any> {
    const loadingUrl = url + crypto.randomUUID();
    const shouldShow = !hideLoading;
    if (shouldShow) {
      this.loadingService.addToLoadingQueue(loadingUrl);
    }
    const options = {
      body: body,
    };
    return this.http.delete(`${url}`, options).pipe(
      tap((results) => {
        if (shouldShow) {
          this.loadingService.removeFromLoadingQueue(loadingUrl);
        }
        return results;
      }),
      share()
    );
  }
}
